import { Component, OnDestroy, OnInit } from '@angular/core';
import { ISession } from '../../../models/session';
import { SessionBase } from '../session-base';
import { ActivatedRoute } from '@angular/router';
import { SessionsService } from '../sessions.service';
import { StatsService } from './stats.service';
import { IPhase, phases as _phases } from './stats';
import { TranslateService } from '@ngx-translate/core';
import { takeUntil, tap } from 'rxjs/operators';
import { forkJoin } from 'rxjs/observable/forkJoin';
import * as moment from 'moment';
import { Subject } from 'rxjs';

@Component({
  selector: 'session-stats',
  templateUrl: './stats.component.html',
  styleUrls: ['./stats.component.scss']
})
export class StatsComponent extends SessionBase implements OnInit, OnDestroy {
  public currentPhase: 'before' | 'during' | 'after' = 'before';
  public session: ISession;
  public exportLinks;
  public phases: Array<IPhase>;
  public sessionStart: Date;
  public sessionStop: Date;
  private componentDestroyed$ = new Subject();

  constructor(
    private route: ActivatedRoute,
    private sessionsService: SessionsService,
    private statsService: StatsService,
    private translateService: TranslateService
  ) {
    super();
  }

  ngOnDestroy() {
    this.componentDestroyed$.next(true);
    this.componentDestroyed$.complete();
  }

  ngOnInit() {
    const getTime = url => this.statsService.call(url);
    super
      .getSession$(this.route.parent.data)
      .pipe(
        tap(session => {
          forkJoin(
            getTime(this.statsService.timeStarted(this.session.id)),
            getTime(this.statsService.timeStopped(this.session.id))
          ).subscribe(([started, stopped]) => {
            this.sessionStart = started.timestamp
              ? moment.unix(started.timestamp).toDate()
              : session.date;
            this.sessionStop = stopped.timestamp
              ? moment.unix(stopped.timestamp).toDate()
              : session.expirationdatetime;

            this.phases = _phases(
              this.statsService,
              this.translateService,
              this.sessionStart,
              this.sessionStop
            );
          });
        })
      )
      .subscribe();
    this.exportLinks = this.sessionsService.getExports(this.session.id);

    const source$ = this.translateService.onLangChange;
    source$
      .pipe(
        takeUntil(this.componentDestroyed$),
        tap(() => {
          this.phases = _phases(
            this.statsService,
            this.translateService,
            this.sessionStart,
            this.sessionStop
          );
        })
      )
      .subscribe();
  }

  getHeaderStyle(columns: number) {
    switch (columns) {
      case 3:
        return 'col-md-4';
      case 4:
        return 'col-md-3';
      case 6:
        return 'col-md-2';
      default:
        return 'col-md-1';
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/modules/sessions/stats/stats.component.ts